import React, { useState } from "react";
import X from "../assets/images/X.png";
import Linkedin from "../assets/images/Linkedin.png";
import GenericPopup from "./popup/it/footer-popup";
import arrowIconWhite from "../assets/images/Vector_btn.png";

export default function Footer() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <>
      <section className="bg-[#0080E0] flex flex-col gap-5 items-center py-10 md:py-16 px-5">
        <h2 className="text-[34px] text-white font-normal">Seguici su</h2>

        <div className="flex flex-row gap-6">
          <a
            href="https://x.com/RealeGroup"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Seguici su X (Twitter)"
          >
            <img className="w-[30px]" src={X} alt="" />
          </a>
          <a
            href="https://www.linkedin.com/company/reale-group/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Seguici su LinkedIn"
          >
            <img className="w-[30px]" src={Linkedin} alt="" />
          </a>
        </div>

        <p className="text-center text-white text-[16px] md:text-[20px] max-w-2xl">
          Reale Mutua Assicurazioni - Via Corte d'Appello 11, 10122 Torino<br />
          Iscritta al Registro delle Imprese di Torino, R.E.A. n.9806 - Partita IVA 11998320011 / C.F. 00875360018
        </p>

        <div className="flex flex-wrap justify-center gap-2 text-white text-[16px] md:text-[18px] font-bold">
          <a
            href="https://www.realegroup.eu/IT/careers"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Lavora con noi
          </a>
          <span>-</span>
          <a
            href="/cookie-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Cookie Policy
          </a>
          <span>-</span>
          <a
            href="https://www.realegroup.eu/IT/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Privacy Policy
          </a>
          <span>-</span>
          <a
            href="https://www.realegroup.eu/IT/accessibilita"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Accessibilità
          </a>
        </div>

          <button
            className="bt-secondary text-sm px-4 py-2 mt-2"
            onClick={() => setIsPopupOpen(true)}
          >
            <img src={arrowIconWhite} alt="Arrow" className="inline-block mr-2 w-[20px] h-[20px]" />
            Credits e Contatti
          </button>

      </section>

      {/* Popup dei Credits */}
      <GenericPopup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
    </>
  );
}